import { combineReducers } from 'redux';

import consultaAdicaoCategoria from './consultaAdicaoCategoria/reducer';
import gerarRenach from './gerarRenach/reducer';

export default combineReducers({
	consultaAdicaoCategoria,
	gerarRenach,
});
